import { render, staticRenderFns } from "./costInput.vue?vue&type=template&id=2aa7f970&scoped=true"
import script from "./costInput.vue?vue&type=script&lang=js"
export * from "./costInput.vue?vue&type=script&lang=js"
import style0 from "./costInput.vue?vue&type=style&index=0&id=2aa7f970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa7f970",
  null
  
)

export default component.exports